<template>
    <div id="age-verifier" v-if="getSettings && getShowAgeVerification">
        <div class="inner">
            <img v-if="getSettings.LogoContrast" :src="getSettings.LogoContrast.URL">
            <p>{{getSettings.AgeVerificationMessage}}</p>
            <button class="btn btn-light" @click="verifyAge">Yes, let me in</button>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "AgeVerifier",
        computed: {
            ...mapGetters(['getSettings', 'getShowAgeVerification'])
        },
        methods: {
            ...mapActions(['fetchSettings', 'checkAgeVerification', 'verifyAge'])
        },
        created() {
            // this.fetchSettings();
            this.checkAgeVerification();
        }
    }
</script>


